"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterReplyToOffer = void 0;
const reply_action_1 = __importDefault(require("@app/request/reply-action"));
const util_1 = require("@app/util");
const i18n_1 = require("@app/util/i18n");
const _ui_1 = require("@ui");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importDefault(require("react"));
const FooterReplyToOffer = ({ isEmployeeCalendar, iAmCandidate, shifts, details, offer, auth, selectedSwap, close, meId, allowMultipleShiftsOnOneDay, }) => {
    const offerIsSwap = Boolean(offer?.swaps?.length);
    const replyOffer = (offer, answer) => {
        const offerActionId = offer?.announceAction ? offer.announceAction.id : null;
        const offerIsSwap = Boolean(offer?.swaps?.length);
        if (!offerActionId)
            return;
        (0, reply_action_1.default)({
            actions: [offerActionId],
            reply: answer,
            data: offerIsSwap && selectedSwap
                ? {
                    shift: selectedSwap.shiftId,
                }
                : undefined,
        }, auth)
            .then(() => {
            close();
            // reload the employee calendar
            if (window.reloadEmployeeCalendar) {
                setTimeout(() => {
                    ;
                    window.reloadEmployeeCalendar?.();
                }, 500);
            }
        })
            .catch(() => { });
    };
    const problemAcceptingOffer = () => {
        // prevent accepting a swap offer until the user has selected a shift to swap for it
        if (offerIsSwap && !selectedSwap) {
            return 'mustSelectSwapOption';
        }
        // prevent accepting shift if it would overlap some other shift of ours
        if (shifts?.some((s) => s.userId === meId &&
            (0, moment_1.default)(s.period.start).isSameOrBefore(details.period.end) &&
            (0, moment_1.default)(s.period.end).isSameOrAfter(details.period.start) &&
            (!offerIsSwap || !selectedSwap || selectedSwap.shiftId !== s.id) // exception: the shift can overlap with selected swap option if it's a 'swap' offer
        ))
            return 'cannotAcceptShiftAlreadyHaveOne';
        // if WS doesn't have 'allowMultipleShiftsOnOneDay' setting enabled, prevent accepting
        // a shift if we already have a shift that day
        if (!allowMultipleShiftsOnOneDay) {
            if (shifts?.find((s) => s.userId === meId &&
                (0, moment_1.default)(s.period.start).isSame(details.period.start, 'day')))
                return 'cannotAcceptShiftAlreadyHaveOne';
        }
        return '';
    };
    if (!details)
        return null;
    return iAmCandidate ? (isEmployeeCalendar ? (react_1.default.createElement("div", { style: {
            display: 'flex',
            justifyContent: 'end',
            gap: '0.5rem',
            width: '100%',
        } },
        react_1.default.createElement(_ui_1.Button, { onClick: () => close() }, (0, i18n_1.t)('CANCEL')),
        react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.OUTLINED, color: _ui_1.Button.COLORS.RED, size: _ui_1.Button.SIZES.EXTRA, onClick: () => {
                if (offer.announceAction)
                    replyOffer(offer, 'no');
            } }, (0, i18n_1.t)('CONT_ANSWER_NO')),
        react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.CONTAINED, color: _ui_1.Button.COLORS.GREEN, size: _ui_1.Button.SIZES.EXTRA, onClickActiveWhenDisabled: true, disabled: !!problemAcceptingOffer(), onClick: () => {
                if (!problemAcceptingOffer()) {
                    if (offer.announceAction)
                        replyOffer(offer, 'yes');
                }
                else {
                    const problemCode = problemAcceptingOffer();
                    if (problemCode !== '') {
                        util_1.notification.error({ code: problemCode, message: undefined });
                    }
                }
            } }, (0, i18n_1.t)('CONT_ANSWER_YES')))) : null) : details.userId === meId ? (react_1.default.createElement(react_1.default.Fragment, null, (0, i18n_1.t)('CONT_SHIFT_IS_YOURS_SO_FAR'))) : offer.authorId === meId ? (react_1.default.createElement(react_1.default.Fragment, null, (0, i18n_1.t)('CONT_YOU_ARE_AUTHOR'))) : (react_1.default.createElement(react_1.default.Fragment, null, (0, i18n_1.t)('CONT_CANNOT_ANSWER')));
};
exports.FooterReplyToOffer = FooterReplyToOffer;
